"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOfficeUsageInputs = void 0;
const utils_1 = require("../utils");
const types_1 = require("./types");
const validateTotalAndOfficeAreas = ({ totalHomeArea, officeArea, }) => {
    if (officeArea >= totalHomeArea) {
        throw new Error("Office area should be less than total home area");
    }
};
const MAX_MONTHS_USED = 12;
const validateMonthsUsed = (monthsUsed) => {
    if (monthsUsed > MAX_MONTHS_USED) {
        throw new Error(`Months used should be less or equal to ${MAX_MONTHS_USED}`);
    }
};
const validateOfficeUsageInputs = (inputs) => {
    const { homeOwnershipType, totalHomeArea, officeArea, monthsUsed, usagePeriodOperatingHomeExpenses, annualOtherHomeExpenses, annualOtherOfficeExpenses, paidHomeExpensesInputTax16, paidHomeExpensesInputTax19, paidOfficeExpensesInputTax16, paidOfficeExpensesInputTax19, } = inputs;
    (0, utils_1.validateAmounts)([
        totalHomeArea,
        officeArea,
        monthsUsed,
        homeOwnershipType === types_1.HomeOwnershipType.RENTAL
            ? inputs.monthlyRent
            : inputs.annualHomeDepreciation,
        usagePeriodOperatingHomeExpenses,
        annualOtherHomeExpenses,
        annualOtherOfficeExpenses,
        paidHomeExpensesInputTax16,
        paidHomeExpensesInputTax19,
        paidOfficeExpensesInputTax16,
        paidOfficeExpensesInputTax19,
    ]);
    validateTotalAndOfficeAreas({ totalHomeArea, officeArea });
    validateMonthsUsed(monthsUsed);
};
exports.validateOfficeUsageInputs = validateOfficeUsageInputs;
//# sourceMappingURL=utils.js.map